<div class="background"></div>

<ic-task-list
	*userHasPermission="['MEDAPP.CARE']; else noPermission"
	[activities]="planningActivities$ | async"
	[loading]="loading$ | async"
	[shift]="currentShift$ | async"
	[tasks]="tasks$ | async"
	(create)="createDynamicTask($event)"
	(selectTask)="goToDetail($event)"
/>

<ng-template #noPermission>
	<empty-state icon="fa fa-tasks" message="{{ 'general.no_permissions' | translate }}" />
</ng-template>
